/**
 * Maximum size of a single file a user may upload through Hera (1 GB).
 */
export const MAX_UPLOAD_FILE_SIZE_BYTES = 1024 * 1024 * 1024
export const MAX_UPLOAD_FILE_SIZE_LABEL = '1 GB'

/**
 * @param {File} file
 * @returns {boolean} true when the file is larger than the upload limit
 */
export function isFileTooLarge(file) {
    return Boolean(file) && file.size > MAX_UPLOAD_FILE_SIZE_BYTES
}

/**
 * Builds the error shown when one or more files exceed the upload limit.
 * @param {File[]} files oversized files
 * @returns {string}
 */
export function getFileTooLargeMessage(files) {
    const names = files.map(file => `"${file.name}"`).join(', ')
    const subject = files.length > 1 ? `These files exceed` : `This file exceeds`
    return `${subject} the ${MAX_UPLOAD_FILE_SIZE_LABEL} upload limit and cannot be uploaded: ${names}`
}

/**
 * Splits a FileList (or array of files) into files within the upload limit and oversized files.
 * @param {FileList|File[]} files
 * @returns {{ accepted: File[], rejected: File[] }}
 */
export function partitionFilesBySize(files) {
    const accepted = []
    const rejected = []
    Array.from(files || []).forEach(file => {
        (isFileTooLarge(file) ? rejected : accepted).push(file)
    })
    return { accepted, rejected }
}

/**
 * @param {File} file
 * @returns {boolean} true when the file name contains an asterisk, which breaks the upload (HERA-9114)
 */
export function hasAsteriskInFileName(file) {
    return Boolean(file) && typeof file.name === 'string' && file.name.includes('*')
}

/**
 * Builds the error shown when a file name contains an asterisk.
 * @param {File} file
 * @returns {string}
 */
export function getAsteriskInFileNameMessage(file) {
    return `The file name "${file.name}" contains an asterisk (*), which is not allowed. Rename the file to remove the asterisk, then attach it again.`
}
